export default function testimonialsUI () {
	$('.testimonials').each(function() {
		moveTestimonialTitles($(this));

		toggleTestimonials($(this));
	})
}

const moveTestimonialTitles = ($section) => {
	const $testimoinals = $section.find('.testimonial');
	const $testimonialsNav = $section.find('.testimonials__nav');

	$testimoinals.each(function() {
		const $testimonialTitle = $(this).find('.testimonials__nav__item');

		$testimonialTitle.appendTo($testimonialsNav);
	});
}

const toggleTestimonials = ($section) => {
	const $testimonialTitles = $section.find('.testimonials__nav__item');
	const $testimonial = $section.find('.testimonials__nav__item');

	$testimonialTitles.first().addClass('active');
	$section.find('.testimonial:first-child').addClass('active');

	$testimonialTitles.each(function() {
		const $title = $(this);

		$title.on('click', function(event) {
			event.preventDefault();

			$(this).addClass('active').siblings().removeClass('active');

			const target = $(this).attr('href');

			$(target).addClass('active').siblings().removeClass('active');
		});
	});
}
